export const PRODUCT_LEARN_MORE = 'buy_learn_more';
export const PRODUCT_RECOMMEND_ME = 'buy_recommend_me';
export const WIZARD_COMPLETED = 'buy_product_recommendation';
